import type {ReactNode} from 'react';
import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import AutoGraphOutlinedIcon from '@mui/icons-material/AutoGraphOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import StackedBarChartOutlinedIcon from '@mui/icons-material/StackedBarChartOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import {ReactComponent as AmazingAppsIcon} from '@assets/icons/AmazingApps.svg';
import {Routes} from 'constants/routes';
import {DrillingCarpetTabs} from '@pages/GroupedPages/drillingCarpet/useTabsDrillingCarpet';
import {LessonsDatabaseTabs} from '@pages/GroupedPages/lessonsDatabase/useTabsLessonsDatabase';
import {Permission} from 'utils/hooks/permissions/usePermissions';

export type NavigationCardGradient = {
    background: string;
    text: string;
};

export type NavigationCardConfig = {
    titleKey: string;
    icon: ReactNode;
    route: string;
    color: string;
    gradient?: NavigationCardGradient;
    permission: Permission;
};

export const appNavigationCards: NavigationCardConfig[] = [
    {
        titleKey: 'mainCards.ratesAndPricesShort',
        icon: <CurrencyRubleIcon />,
        route: Routes.RatesAndPrices,
        color: 'rgba(94, 154, 255, 1)',
        permission: Permission.Prices,
    },
    {
        titleKey: 'mainCards.project',
        icon: <ContentPasteIcon />,
        route: Routes.Projects,
        color: 'rgba(155, 228, 255, 1)',
        permission: Permission.Projects,
    },
    {
        titleKey: 'mainCards.myResources',
        icon: <WarehouseOutlinedIcon />,
        route: Routes.MyResources,
        color: 'rgba(41, 255, 237, 1)',
        permission: Permission.CAN_VIEW_MY_RESOURCES,
    },
    {
        titleKey: 'mainCards.commonInfoShort',
        icon: <AutoGraphOutlinedIcon />,
        route: Routes.CommonInfo,
        color: 'rgba(41, 255, 173, 1)',
        permission: Permission.CommonInfo,
    },
    {
        titleKey: 'mainCards.lessonsDatabase',
        icon: <BarChartOutlinedIcon />,
        route: `${Routes.LessonsDatabase}/${LessonsDatabaseTabs.NPV_ANALITICS}`,
        color: 'rgba(229, 115, 125, 1)',
        permission: Permission.CanViewIncidentAnalyse,
    },
    {
        titleKey: 'mainCards.monitoring',
        icon: <BarChartOutlinedIcon />,
        route: Routes.Monitoring,
        color: 'rgba(145, 118, 255, 1)',
        permission: Permission.CAN_VIEW_MONITORING,
    },
    {
        titleKey: 'mainCards.smboShort',
        icon: <AutoGraphOutlinedIcon />,
        route: Routes.SMBO,
        color: 'rgba(192, 115, 255, 1)',
        permission: Permission.CAN_VIEW_DRILLING_RIG,
    },
    {
        titleKey: 'mainCards.drillingCarpet',
        icon: <StackedBarChartOutlinedIcon />,
        route: `${Routes.DrillingCarpet}/${DrillingCarpetTabs.CALENDAR_SCHEDULER}`,
        color: 'rgba(0, 191, 165, 1)',
        permission: Permission.CAN_VIEW_DRILLING_CARPET,
    },
];

export const additionalNavigationCards: NavigationCardConfig[] = [
    {
        titleKey: 'Data Manager',
        icon: <AutoGraphOutlinedIcon />,
        route: Routes.DataManager,
        color: 'rgba(132, 95, 255, 1)',
        gradient: {
            background:
                'linear-gradient(180deg, rgba(132, 95, 255, 0.04) 0%, rgba(95, 255, 252, 0.04) 72.6%, rgba(109, 170, 255, 0.04) 100%)',
            text: 'linear-gradient(180deg, #6F4EDB 0%, #5087FF 100%)',
        },
        permission: Permission.CAN_VIEW_FILE_MANAGER,
    },
    {
        titleKey: 'MiniApps',
        icon: <AmazingAppsIcon />,
        route: Routes.Miniapp,
        color: 'rgba(255, 140, 22, 1)',
        permission: Permission.CAN_VIEW_MINIAPPS,
    },
    {
        titleKey: 'mainCards.administrationShort',
        icon: <GroupAddOutlinedIcon />,
        route: Routes.Administration,
        color: 'rgba(255, 245, 157, 1)',
        permission: Permission.CAN_VIEW_ADMIN_PANEL,
    },
];
